import currency from 'currency.js';
import { useQuery } from 'react-apollo';
import { SYSTEM } from '../../../../queries';

const sortVerticals = (verticals) =>
  [...verticals].sort((left, right) => left.index - right.index);

export const getFieldValues = (system) => {
  const verticals = sortVerticals(system.verticals);
  const firstVertical = verticals[0];
  const glass = firstVertical && firstVertical.glass[0];
  const values = {
    id: system.id,
    mark: system.mark,
    qty: system.qty,
    frameColorId: system.frameColor.id,
    autoPrice: system.autoPrice,
    price: currency((firstVertical && firstVertical.priceSqft) || 0),
    widths: verticals.map(({ width }) => ({ value: width })),
    elevations: ((firstVertical && firstVertical.lites) || []).map((value) => ({
      value,
    })),
  };

  if (glass) {
    values.glassCompositionId = glass.glassComposition.id;
    values.glassHeatTreatment = glass.glassComposition.heatTreatment;
    values.glassType = glass.glassComposition.type;
    values.glassThickness = glass.glassComposition.thickness;
    values.glassInterlayer = glass.glassComposition.interlayer;
  }

  return values;
};

const onCompleted = (system, formContext) => {
  const { reset, getValues } = formContext;
  const values = getFieldValues(system);

  reset({ ...getValues(), ...values });
};

export const useInitialValues = ({ systemId, formContext }) => {
  useQuery(SYSTEM, {
    variables: { id: systemId },
    skip: !systemId,
    onCompleted: ({ system }) => onCompleted(system, formContext),
  });
};
